// extracted by mini-css-extract-plugin
module.exports = {"heading":"mainTiles_heading__BRQ_v","buttons":"mainTiles_buttons__Q_4XP","pagination":"mainTiles_pagination__2OTnb","nextPageButton":"mainTiles_nextPageButton__eAAKJ"};